/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Betöltés...',
	'dlg_close': 'Bezárás',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Mégse',
	'dlg_back': 'Vissza',
	'dlg_done': 'Kész',

	// Slider
	'sliderRegionLabel': 'Csúszka vezérlőelem, a bal és a jobb nyílbillentyűkkel mozgathatja a csúszka fogópontjait',
	'sliderHandleLabel': 'Csúszka fogópontja',
	'a11ySliderHandleLabel': '%{sliderValue} csúszka fogópontja',
	'sliderInputLabel': 'érték',

	// Side bar
	'sidebarAdd': 'Hozzáadás',
	'clearTextFilterValue': 'Törlés',
	'missingDataSetData': 'Az adathalmazhoz tartozó adatok nem érhetők el. Frissítse az adathalmazt, vagy lépjen kapcsolatba az adminisztrátorral a forráshoz való hozzáférésért.',

	// Toolbar
	'toolbarRegionLabel': 'Eszközsáv',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Betűtípuscsalád',
	'fontSizeSelect': 'Betűméret',
	'fontColorSelect': 'Szín',
	'fontStyle': 'Stílus',
	'colorPickerTitle': 'Szín kiválasztása',
	'bold': 'Félkövér',
	'italic': 'Dőlt',
	'underline': 'Aláhúzás',
	'fontAlignment': 'Igazítás',
	'justifyLeft': 'Balra igazítás',
	'justifyCenter': 'Középre igazítás',
	'justifyRight': 'Jobbra igazítás',
	'insertOrderedList': 'Rendezett lista',
	'insertUnorderedList': 'Rendezetlen lista',
	'fontColorPicker': 'Színválasztó',
	'textWrap': 'Szöveg tördelése',
	'restore': 'Alapértékek visszaállítása',
	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Eredmények száma: (%{lower} - %{higher})',
	'topbottomPercentLabel': 'Százalék (%{lower}% - %{higher}%)',
	'topbottomSelectOption': 'Első vagy utolsó lehetőség',
	'topbottomOptionLabel': 'Megjelenítés',
	'searchByLabel': 'A következő szerint:',
	'searchNoMatches': 'Nincs találat',
	'topbottomRankColumnLabel': 'Rangsoroszlop hozzáadása táblához',
	'topbottomNone': 'Nincs',
	'topCount': 'Első elemek száma',
	'topPercent': 'Felső %',
	'bottomCount': 'Utolsó elemek száma',
	'bottomPercent': 'Alsó %',
	'searchColumn': 'Oszlop keresése',
	'searchColumnAriaLabel': 'Oszlop keresése. Adja meg a keresett oszlop nevét, majd a lefelé mutató nyíllal keresse meg az oszlopot a listában',
	'searchColumnQualifiedLabel': '%{columnLabel} (%{columnId})',
	'rankColumnLabel': 'Rangsor (%{columnLabel})',
	'topbottomClearLabel': 'Visszaállítás',

	// Format
	'formatAuto': 'Automatikus',
	'formatConvertPercent': 'Decimális átalakítása százalékká',
	'formatAbbreviate': 'Rövidítés',
	'formatUseGrouping': 'Ezres elválasztó használata',
	'dateStyle': 'Dátum stílusa',
	'dateTimeStyle': 'Dátum/Idő stílus',
	'formatMissingValueCharactersInfo': 'A hiányzó érték karakterek az érték hiánya esetén megjelenítendő karaktereket határozzák meg. ',
	'currencySymbolLabel': 'Pénznemszimbólum',
	'customSymbolPlaceholder': 'Szimbólum hozzáadása',
	'customSymbolLabelInfo': 'Itt adhatja meg az egyéni szimbólumként használt karakter(eke)t. Ez a szimbólum megelőzi a számot és minden egyéb jelet. ',
	'numberLabel': 'Szám címkéje',
	'numberPositionLabel': 'Címke pozíciója',
	'numberLabelInfo': 'A formázott szám címkéjét adja meg, amely a címkepozíciótól függően előtétként vagy utótagként kerül elhelyezésre. ',
	'nullValueDefault': '<alapérték>',
	'nullValueContent': '(nincs érték)',
	'default': 'Alapértelmezett',
	'beginning': 'Kezdete',
	'end': 'Vége',
	'formatLabel': 'Formátum kiválasztása',

	// More data indicator
	'moreDataIndicator': 'Adatait a rendszer %{threshold} elemre levágta. Alkalmazzon szűrőt kevesebb elem megjelenítéséhez.',

	// Expanded View / Focus mode
	'evCollapse': 'Visszazárás',
	'duplicate': 'Többszörözés',
	'copyOf': '%{name} másolata',
	'unableToDuplicateBoard': 'A(z) "%{name}" nem másolható.',

	// Widget list
	'errorLoadingWidgetList': 'Az objektumokat nem lehet betölteni.',

	// Custom widgets
	'customWidget': 'Egyéni eszközelem'
});
